/** Report categories — keep in sync with client/firebase-functions/reportCategories.js */

export const REPORT_CATEGORIES = [
  {
    id: 'scam',
    name: 'Scam Attempt',
    riskWeight: 1.0,
    alertTier: 'danger',
  },
  {
    id: 'harassment',
    name: 'Harassment',
    riskWeight: 0.9,
    alertTier: 'danger',
  },
  {
    id: 'robocall',
    name: 'Robocall',
    riskWeight: 0.75,
    alertTier: 'caution',
  },
  {
    id: 'spam-call',
    name: 'Spam Call',
    riskWeight: 0.7,
    alertTier: 'caution',
  },
  {
    id: 'sales',
    name: 'Sales Call',
    riskWeight: 0.5,
    alertTier: 'caution',
  },
  {
    id: 'wrong-number',
    name: 'Wrong Number',
    riskWeight: 0.1,
    alertTier: 'none',
  },
  {
    id: 'private-individual',
    name: 'Private individual (not a business)',
    riskWeight: 0,
    alertTier: 'none',
    marksPrivate: true,
  },
  {
    id: 'legitimate-business',
    name: 'Legitimate business call',
    riskWeight: 0,
    alertTier: 'none',
    marksBusiness: true,
  },
];

const CATEGORY_BY_ID = new Map(REPORT_CATEGORIES.map((c) => [c.id, c]));

export function getCategoryById(categoryId) {
  return CATEGORY_BY_ID.get(categoryId || 'spam-call') || CATEGORY_BY_ID.get('spam-call');
}

export function resolveCategoryMeta(categoryId) {
  const category = getCategoryById(categoryId);
  return {
    riskWeight: category.riskWeight ?? 0,
    alertTier: category.alertTier || 'none',
    marksPrivate: category.marksPrivate === true,
    marksBusiness: category.marksBusiness === true,
    isSpam: (category.alertTier || 'none') === 'caution' || category.id === 'spam-call',
  };
}

export function resolveMarksPrivate(categoryId) {
  return getCategoryById(categoryId).marksPrivate === true;
}

/** Legacy: caution-tier categories count as spam for backward compat fields. */
export function resolveReportIsSpam(categoryId) {
  const tier = getCategoryById(categoryId).alertTier;
  return tier === 'caution';
}
